import type { PageData } from '../../../../_metronic/helpers/utils/types';

export const blogData: PageData = [
  {
    formId: 'form1',
    heading: 'Blog Section',
    data: [
      { id: 'metaName', label: 'Meta title', type: 'input' },
      { id: 'metaContent', label: 'Meta description', type: 'input' },
      { id: 'label', label: 'Text for blog links', type: 'input' }
    ]
  }
];
